import { PO_BOX_REGEX_BY_COUNTRY } from 'constants/patterns';
import { PO_BOX_BLOCKED, isFeatureEnabled } from 'utilities/features';

const isPOBoxAddress = (store, addressLines = []) => {
  const pattern =
    PO_BOX_REGEX_BY_COUNTRY[store] || PO_BOX_REGEX_BY_COUNTRY.DEFAULT;
  const regex = new RegExp(pattern, 'gim');

  return addressLines.some((addressLine) => regex.test(addressLine));
};

const isPOBoxBlocked = (orderData = {}) => {
  const { cart_summary: lineItems = [] } = orderData;

  return (
    isFeatureEnabled(PO_BOX_BLOCKED) ||
    lineItems.some((li) => !li.pobox_eligible)
  );
};

export { isPOBoxAddress, isPOBoxBlocked };
